module.exports = __webpack_public_path__ + "img/login.70437f66.svg";